import { Swiper, SwiperSlide } from 'swiper/react';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/modals/');

export default function SolarPanels() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [activeRV, setActiveRV] = useState(0);
    const [swiperRV, setSwiperRV] = useState({ activeIndex: 0 });
    const [activeOG, setActiveOG] = useState(0);
    const [swiperOG, setSwiperOG] = useState({ activeIndex: 0 });

    const solarPanelsData = {
        rv: {
            [t('presale.product.modals.solar_panels_rv_swiper1_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper1_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec4'),
                    t('presale.product.modals.solar_panels_rv_swiper1_spec5'),
                ],
                img: ['100W-rigid.webp', '100W-rigid.png'],
            },
            [t('presale.product.modals.solar_panels_rv_swiper2_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper2_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper2_spec4'),
                ],
                img: ['100W-flexible.webp', '100W-flexible.png'],
            },
            [t('presale.product.modals.solar_panels_rv_swiper3_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_rv_swiper3_spec1'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec2'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec3'),
                    t('presale.product.modals.solar_panels_rv_swiper3_spec4'),
                ],
                img: ['400W-portable.webp', '400W-portable.png'],
            },
        },
        offGrid: {
            [t('presale.product.modals.solar_panels_off_grid_swiper1_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec1'),
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec2'),
                    t('presale.product.modals.solar_panels_off_grid_swiper1_spec3'),
                ],
                img: ['400W-rigid.webp', '400W-rigid.png'],
            },
            [t('presale.product.modals.solar_panels_off_grid_swiper2_title')]: {
                specList: [
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec1'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec2'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec3'),
                    t('presale.product.modals.solar_panels_off_grid_swiper2_spec4'),
                ],
                img: ['400W-portable.webp', '400W-portable.png'],
            },
        },
    };

    const renderSwiper = (data = {}) => {
        const dom = [];
        for (const key in data) {
            const { specList, img } = data[key];
            dom.push(
                <SwiperSlide>
                    <div className="product-img">
                        <EFPic name={img} className="fullImgs" alt={key} />
                    </div>
                    <div className="spec-list">
                        {specList.map((item: any, index: number) => (
                            <div className="spec-item" key={index}>
                                <div className="text">{item}</div>
                            </div>
                        ))}
                    </div>
                </SwiperSlide>,
            );
        }
        return dom;
    };

    const onTabnavScrollRV = (index: number) => {
        const separatorWidth = document.querySelector('.separator')?.scrollWidth || 10;
        const tabnavWidth = document.querySelector('.tabnav-rv')?.scrollWidth || 315;
        const currentTabnavWidth = document.querySelector(`.tabnav-rv${index}`)?.scrollWidth || 0;
        const offset = (tabnavWidth - currentTabnavWidth) / 2;
        let scrollWidth = 0;
        for (let i = 0; i < index; i++) {
            const width = document.querySelector(`.tabnav-rv${i}`)?.scrollWidth || 0;
            scrollWidth += width + separatorWidth;
        }
        document.querySelector('.tabnav-items-rv')?.scrollTo({ left: scrollWidth - offset, behavior: 'smooth' });
    };

    const onSwiperSlideToRV = (index: number) => {
        if (swiperRV && index !== activeRV) {
            swiperRV?.slideTo(index);
        }
    };

    const onTabnavScrollOG = (index: number) => {
        const separatorWidth = document.querySelector('.separator')?.scrollWidth || 10;
        const tabnavWidth = document.querySelector('.tabnav-rv')?.scrollWidth || 315;
        const currentTabnavWidth = document.querySelector(`.tabnav-rv${index}`)?.scrollWidth || 0;
        const offset = (tabnavWidth - currentTabnavWidth) / 2;
        let scrollWidth = 0;
        for (let i = 0; i < index; i++) {
            const width = document.querySelector(`.tabnav-og${i}`)?.scrollWidth || 0;
            scrollWidth += width + separatorWidth;
        }
        document.querySelector('.tabnav-items-og')?.scrollTo({ left: scrollWidth - offset, behavior: 'smooth' });
    };

    const onSwiperSlideToOG = (index: number) => {
        if (swiperOG && index !== activeOG) {
            swiperOG?.slideTo(index);
        }
    };

    return (
        <div className={`${css.SolarPanels} SolarPanels`}>
            <div className="rv">
                <div className="texta-title-a1">{t('presale.product.modals.solar_panels_title')}</div>
                <div className="texta-title-a2">{t('presale.product.modals.solar_panels_rv_title')}</div>
                <div className="swiper-content">
                    <div className="tablist-wrapper">
                        <div className="tabnav tabnav-rv">
                            <ul className="tabnav-items tabnav-items-rv">
                                <li className={`tabnav-item tabnav-rv0 ${activeRV === 0 && 'current'}`} onClick={() => onSwiperSlideToRV(0)}>
                                    <span className="tabnav-link">{t('presale.product.modals.solar_panels_rv_swiper1_title')}</span>
                                </li>
                                <span className="separator" aria-hidden="true">
                                    /
                                </span>
                                <li className={`tabnav-item tabnav-rv1 ${activeRV === 1 && 'current'}`} onClick={() => onSwiperSlideToRV(1)}>
                                    <span className="tabnav-link">{t('presale.product.modals.solar_panels_rv_swiper2_title')}</span>
                                </li>
                                <span className="separator" aria-hidden="true">
                                    /
                                </span>
                                <li className={`tabnav-item tabnav-rv2 ${activeRV === 2 && 'current'}`} onClick={() => onSwiperSlideToRV(2)}>
                                    <span className="tabnav-link">{t('presale.product.modals.solar_panels_rv_swiper3_title')}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <Swiper
                        className="rv-swiper"
                        slidesPerView={'auto'}
                        spaceBetween={30}
                        initialSlide={0}
                        preloadImages={false}
                        lazy={true}
                        centeredSlides={true}
                        grabCursor={true}
                        pagination={{
                            clickable: true,
                        }}
                        loop
                        onSlideChange={(swiper: any) => {
                            const { activeIndex } = swiper;
                            setActiveRV(activeIndex % 3 || 0);
                            onTabnavScrollRV(activeIndex % 3);
                        }}
                        onSwiper={(swiper: any) => setSwiperRV(swiper)}
                    >
                        {renderSwiper(solarPanelsData.rv)}
                    </Swiper>
                </div>
            </div>
            <div className="off-grid">
                <div className="texta-title-a1">{t('presale.product.modals.solar_panels_title')}</div>
                <div className="texta-title-a2">
                    {t(locale === 'kr' ? 'presale.product.modals.solar_panels_off_grid_title_h5' : 'presale.product.modals.solar_panels_off_grid_title')}
                </div>
                <div className="swiper-content">
                    <div className="tablist-wrapper">
                        <div className="tabnav tabnav-og">
                            <ul className="tabnav-items tabnav-items-og">
                                <li className={`tabnav-item tabnav-og0 ${activeOG === 0 && 'current'}`} onClick={() => onSwiperSlideToOG(0)}>
                                    <span className="tabnav-link">{t('presale.product.modals.solar_panels_off_grid_swiper1_title')}</span>
                                </li>
                                <span className="separator" aria-hidden="true">
                                    /
                                </span>
                                <li className={`tabnav-item tabnav-og1 ${activeOG === 1 && 'current'}`} onClick={() => onSwiperSlideToOG(1)}>
                                    <span className="tabnav-link">{t('presale.product.modals.solar_panels_off_grid_swiper2_title')}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <Swiper
                        className="off-grid-swiper"
                        slidesPerView={'auto'}
                        spaceBetween={30}
                        initialSlide={0}
                        preloadImages={false}
                        lazy={true}
                        centeredSlides={true}
                        grabCursor={true}
                        pagination={{
                            clickable: true,
                        }}
                        loop
                        onSlideChange={(swiper: any) => {
                            const { activeIndex } = swiper;
                            setActiveOG(activeIndex % 2 || 0);
                            onTabnavScrollOG(activeIndex % 2);
                        }}
                        onSwiper={(swiper: any) => setSwiperOG(swiper)}
                    >
                        {renderSwiper(solarPanelsData.offGrid)}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
